export default "__VITE_ASSET__cIP2zAL9__"